'use strict';

const CONTEXT_KEY = '__react-amphtml-ampscripts__';
const AMP = 'amphtml engine v0.js script';
const AMP4ADS = 'amp4ads engine amp4ads-v0.js script';
const AMP_SRCS = {
  [AMP]: 'https://cdn.ampproject.org/v0.js',
  [AMP4ADS]: 'https://cdn.ampproject.org/amp4ads-v0.js'
};

exports.AMP = AMP;
exports.AMP4ADS = AMP4ADS;
exports.AMP_SRCS = AMP_SRCS;
exports.CONTEXT_KEY = CONTEXT_KEY;
//# sourceMappingURL=constants.js.map
